// extracted by mini-css-extract-plugin
export default {"message":"Message_message__JAYpv","success":"Message_success__kfNWM","info":"Message_info__-ihDo","warning":"Message_warning__L4Upu","error":"Message_error__GLzn6"};